<template>
    <div :class="{ 'wm-toastui-dark': isDark }">
        <viewer :initial-value="value || ''" />
    </div>
</template>

<script>
import { Viewer } from '@toast-ui/vue-editor'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import '@/assets/toastui-editor-dark.css'

export default {
    name: 'MarkdownViewer',
    components: {
        Viewer,
    },
    computed: {
        isDark() {
            return this.$vuetify.theme.dark
        },
    },
    props: {
        value: String,
    },
}
</script>
